function requestReview() {
  return Promise.resolve();
}
var StoreReview = Object.freeze({
  requestReview
});
export {
  StoreReview
};
//# sourceMappingURL=unavailable.js.map
